module.exports = __webpack_public_path__ + "img/how-it-work-01.af674791.png";